import { render } from "./ServicesClinic.vue?vue&type=template&id=71a94fa0"
import script from "./ServicesClinic.vue?vue&type=script&lang=js"
export * from "./ServicesClinic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__